import React from "react";
import VuzenikLogo from "../assets/vuzenik-logo.png";
//import "./Navbar.css"; // optional if you want separate css later

function Navbar() {
  return (
    <header className="navbar">
      <div className="container nav-content">
        <div className="brand">
          <img
            src={VuzenikLogo}
            alt="Vuzenik Technologies"
            className="brand-logo"
          />
          <div className="brand-text">
            <span className="brand-main">Vuzenik</span>
            <span className="brand-sub">Technologies</span>
          </div>
        </div>

        <nav className="nav-links">
          <a href="#who-we-are">Who we are</a>
          <a href="#what-we-do">What we do</a>
          <a href="#services">Services</a>
          <a href="#industries">Industries</a>
          <a href="#case-studies">Case studies</a>
          <a href="#insights">Insights</a>
          <a href="#careers">Careers</a>
        </nav>

        <div className="nav-actions">
          <button className="nav-search" aria-label="Search">
            🔍
          </button>
          <a href="#contact" className="btn-primary">
            Contact us
          </a>
          <button className="nav-lang">EN ▾</button>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
